import { useRouteMatch } from 'react-router-dom';
import RecurringPayments from 'assets/js/pages/recurring-payments/RecurringPayments';
import { RecurringPlanDrawer } from 'assets/js/pages/recurring-payments/RecurringPlanDrawer';
import { DrawerRoute } from 'components/drawer-route';
import { Route } from 'components/router/Route';

const RecurringPlansRouter = () => {
    const match = useRouteMatch();

    return (
        <>
            <DrawerRoute path={`${match.path}/:plan_id(\\d+)`} component={RecurringPlanDrawer} />
            <Route path={match.path} component={RecurringPayments} />
        </>
    );
};

export { RecurringPlansRouter };
